import { types } from "../action-types";

const initialState = {
  loading: false,
  talents: [],
  error: false,
};

const talentSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SEARCH_TALENTS_INIT:
      return { ...state, loading: true, error: false };
    case types.SEARCH_TALENTS_SUCCESS:
      return { ...state, loading: false, talents: action.payload };
    case types.SEARCH_TALENTS_FAILURE:
      return { ...state, loading: false, talents: [], error: true };
    default:
      return state;
  }
};

export default talentSearchReducer;
